<template>
    <div id="myChart" :style="{width: '100%', height: '500px'}"></div>
</template>

<script>
import { numReport } from '@/api/common'
import Lockr from 'lockr'

export default {
    name: "grammarData",
    // learnWordNum
    data() {
        return {
            SeriesData:[],
            xAxisData: [],
            typeName: ''
        };
    },
    methods: {
        async getDataSource() {
            let params = {
                token: Lockr.get('token'),
                type: this.$route.meta.type == 'word' ? 1 : 2
            }
            let result = await numReport(params)
            if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                this.xAxisData = result.data.time.reverse()
                this.SeriesData = result.data.value.reverse()
                this.drawLine();
            } else {
                this.$message({
                    message: result.msg,
                    type: 'warning'
                });
            }
        },
        drawLine() {
            // 基于准备好的dom，初始化echarts实例
            let myChart = this.$echarts.init(document.getElementById('myChart'))
            // 绘制图表
            let colors = ['#F56C6C'];
            myChart.setOption({
                color: colors,
                title: {
                    text: `【最近一周内${this.typeName}学习单词数量图表】`,
                    x: 'center',
                    y: 'top',
                    textAlign: 'left',
                    padding:[5,10],
                    textStyle: {
                        color: '#333'
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    showContent:false, //是否显示提示框浮层
                    axisPointer: { // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                legend: {
                    left:'30',
                    data: ['', '', '', `${this.typeName}数量`],
                    textStyle: {
                        color: '#333',
                        fontSize: 15
                    }
                },
                calculable: true,
                toolbox: {
                    show: true,
                    feature: {
                        magicType: { show: true, type: ['line', 'bar'] },
                        saveAsImage: { show: true }
                    },
                    iconStyle: {
                        borderColor: '#333'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    top:'18%',
                    containLabel: true
                },
                xAxis: [{
                    type: 'category',
                    data: this.xAxisData,
                    axisTick: {
                        alignWithLabel: true
                    },
                    axisLabel: {
                        show: true,
                        textStyle: {
                            color: "#333",
                            fontSize: 13,
                        }
                    },
                }],
                yAxis: [{
                    type: 'value',
                    axisLabel: {
                        show: true,
                        textStyle: {
                            color: "#333",
                            fontSize: 13,
                        }
                    },
                }],
                series: [{
                    name: `${this.typeName}数量`,
                    type: 'bar',
                    barWidth: '40%',
                    data: this.SeriesData,
                    itemStyle: {
                        normal: {
                            label: {
                                show: true, //开启显示
                                position: 'top', //在上方显示
                                textStyle: { //数值样式
                                    color: 'black',
                                    fontSize: 16
                                }
                            }
                        }
                    },
                }]
            });
        }
    },
    created() {
        this.typeName = this.$route.meta.type == 'word' ? '单词' : '语法'
        this.getDataSource()
    },
    mounted() {
        this.drawLine();
    },
}
</script>

<style scoped lang='less'>

</style>